import { Checkbox } from "antd";
import React from "react";

const SystemMaintenanceClosed = () => {
  const onChange = (e) => {
    if (e.target.checked) {
      localStorage.setItem("maintenance-modal-16", "not-show");
    } else {
      localStorage.removeItem("maintenance-modal-16");
    }
  };

  return (
    <div>
      <img src="/images/updateNotification.png" style={{ maxWidth: "100%" }} />
      <Checkbox onChange={onChange}>ไม่ต้องแสดงอีก</Checkbox>
    </div>
  );
};

export default SystemMaintenanceClosed;
